"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Text_1 = __importDefault(require("../../Text"));
var Box_1 = __importDefault(require("../../Box"));
var Button_1 = __importDefault(require("../../Button"));
var Input_1 = __importDefault(require("../../Input"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var validation_1 = require("../../utils/validation");
var analyticUtils_1 = require("../../utils/analyticUtils");
var cookiesUtils_1 = require("../../utils/cookiesUtils");
var Container = (0, styled_1.default)(Box_1.default)({
    backgroundColor: '#3F3F43',
    display: 'flex',
    justifyContent: 'center'
});
var Form = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            maxWidth: theme.maxWidth,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            padding: '72px 36px'
        },
        _b[theme.mediaQueries.md] = {
            flexDirection: 'row',
            alignItems: 'flex-end',
        },
        _b);
});
Form.defaultProps = { as: 'form' };
var Title = (0, styled_1.default)(Text_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: '30px',
        fontWeight: 300,
        letterSpacing: '3px',
        color: theme.colors.contrastText
    });
});
var Subtitle = (0, styled_1.default)(Text_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            fontSize: '20px',
            letterSpacing: '2px',
            marginTop: '24px',
            color: theme.colors.contrastText
        },
        _b[theme.mediaQueries.md] = {
            marginBottom: '0px',
        },
        _b);
});
var InputField = (0, styled_1.default)(Input_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            marginTop: '36px',
            marginBottom: '36px',
            '&::placeholder': {
                letterSpacing: '1.8px',
            }
        },
        _b[theme.mediaQueries.md] = {
            marginTop: '0px',
            marginBottom: '0px',
        },
        _b);
});
var SubscribeButton = (0, styled_1.default)(Button_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%',
            textAlign: 'center',
            fontSize: '12px',
            letterSpacing: '0.6px',
            fontWeight: 500,
            padding: '12px 66px'
        },
        _b[theme.mediaQueries.md] = {
            width: 'auto'
        },
        _b);
});
var SubscribeForm = function (props) {
    var _a = props || {}, submitUrl = _a.submitUrl, title = _a.title, subtitle = _a.subtitle, inputPlaceholder = _a.inputPlaceholder, _b = _a.inputErrorMessage, inputErrorMessage = _b === void 0 ? 'Not valid input' : _b, _c = _a.serverErrorMessage, serverErrorMessage = _c === void 0 ? 'Error' : _c, _d = _a.successMessage, successMessage = _d === void 0 ? 'Success' : _d, button = _a.button, footerRegion = _a.footerRegion;
    var _e = (0, react_1.useState)(''), value = _e[0], setValue = _e[1];
    var _f = (0, react_1.useState)(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = (0, react_1.useState)(''), errorMessage = _g[0], setErrorMessage = _g[1];
    var _h = (0, react_1.useState)(false), submitted = _h[0], setSubmitted = _h[1];
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var analyticUtils, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!(0, validation_1.isEmail)(value)) {
                        return [2 /*return*/, setErrorMessage(inputErrorMessage)];
                    }
                    if (!submitUrl) {
                        return [2 /*return*/, setErrorMessage(serverErrorMessage)];
                    }
                    setErrorMessage('');
                    setIsLoading(true);
                    analyticUtils = new analyticUtils_1.AnalyticUtility(footerRegion);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetch(submitUrl, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ email: value })
                        }).then(function (res) { return res.json(); })];
                case 2:
                    result = _a.sent();
                    // eslint-disable-next-line
                    if (result === null || result === void 0 ? void 0 : result.success) {
                        (0, cookiesUtils_1.setSubscribeCookies)();
                        setSubmitted(true);
                        analyticUtils.subscribeSuccess();
                    }
                    else {
                        throw result;
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('Failed to subscribe', error_1);
                    setErrorMessage(serverErrorMessage);
                    // eslint-disable-next-line
                    analyticUtils.subscribeError(error_1 === null || error_1 === void 0 ? void 0 : error_1.message);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleInputChange = function (e) {
        setValue(e.target.value);
    };
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(Form, { onSubmit: handleSubmit },
            react_1.default.createElement(Box_1.default, { flex: { _: 1, lg: 2 }, mx: { _: 0, md: '24px' } },
                react_1.default.createElement(Title, null, title),
                subtitle && react_1.default.createElement(Subtitle, null, subtitle)),
            submitted
                ?
                    react_1.default.createElement(Box_1.default, { flex: { _: 1, lg: 3 } },
                        react_1.default.createElement(Text_1.default, { color: "contrastText" }, successMessage))
                :
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Box_1.default, { flex: { _: 1, lg: 2 } },
                            react_1.default.createElement(Text_1.default, { color: "error" }, errorMessage),
                            react_1.default.createElement(InputField, { variant: "dark", placeholder: inputPlaceholder, value: value, onChange: handleInputChange })),
                        react_1.default.createElement(Box_1.default, { flex: { _: 1, lg: 1 }, textAlign: "center" },
                            react_1.default.createElement(SubscribeButton, { variant: "outlineClear", type: "submit", loading: isLoading }, button))))));
};
SubscribeForm.defaultProps = defaultProps_1.default;
exports.default = SubscribeForm;
